export enum CustomViewDisplayLayout {
  List,
  Table,
  Chart
}
